import { t } from 'ttag'

import {
  DEFAULT_CANDIDATES_OVERVIEW_QUERY_PARAMS,
  DEFAULT_FINAL_RESULTS_QUERY_PARAMS,
  DEFAULT_INTERVIEWS_QUERY_PARAMS,
  DEFAULT_SEND_INVITES_QUERY_PARAMS,
  DEFAULT_TEST_SCORES_QUERY_PARAMS,
} from 'constants/projects'
import { TAB_NAMES } from 'components/pages/Jobs/model'

const getCandidateStep = ({ hasInterviewModule = true } = {}) => [
  t`create`,
  t`invite`,
  t`test`,
  ...(hasInterviewModule ? [t`interview`, t`recommendations`] : []),
]

const getProjectStep = ({ hasInterviewModule = true } = {}) => [
  t`created`,
  t`candidates added`,
  t`invitations sent`,
  t`test results available`,
  ...(hasInterviewModule ? [t`interviews`, t`recommendations available`] : []),
]

const getCandidateLabel = (status, { hasInterviewModule = true } = {}) => {
  const labels = {
    created: t`created`,
    invited: t`invited`,
    delivered: t`delivered`,
    opened: t`opened`,
    bounced: t`bounced`,
    started: t`started`,
    completed: t`tests completed`,
    rejected: t`rejected`,
    deleted: t`deleted`,
    ...(hasInterviewModule && {
      screened: t`screened`,
      interviewed: t`interviewed`,
      hired: t`hired`,
    }),
  }

  return labels[status]
}

const getProjectLabel = (progress, { hasInterviewModule = true } = {}) => {
  const labels = [
    t`created`,
    t`candidates added`,
    t`invitations sent`,
    t`test results available`,
    ...(hasInterviewModule
      ? [t`interviews`, t`recommendations available`]
      : []),
  ]

  return labels[progress - 1]
}

export const getProjectTab = index => {
  const tabs = {
    0: TAB_NAMES.DETAILS,
    1: TAB_NAMES.OVERVIEW,
    2: TAB_NAMES.INVITES,
    3: TAB_NAMES.TESTS,
    4: TAB_NAMES.INTERVIEWS,
    5: TAB_NAMES.RESULTS,
  }

  return tabs[index]
}

export const getDefaultProjectQueryParams = state => {
  const { activeTab } = state

  const queryParams = {
    [TAB_NAMES.DETAILS]: null,
    [TAB_NAMES.OVERVIEW]: DEFAULT_CANDIDATES_OVERVIEW_QUERY_PARAMS,
    [TAB_NAMES.INVITES]: DEFAULT_SEND_INVITES_QUERY_PARAMS,
    [TAB_NAMES.TESTS]: DEFAULT_TEST_SCORES_QUERY_PARAMS,
    [TAB_NAMES.INTERVIEWS]: DEFAULT_INTERVIEWS_QUERY_PARAMS,
    [TAB_NAMES.RESULTS]: DEFAULT_FINAL_RESULTS_QUERY_PARAMS,
  }

  return queryParams[activeTab]
}

export const mapTypeToSteps = {
  candidate: getCandidateStep,
  project: getProjectStep,
}

export const mapTypeToLabel = {
  candidate: getCandidateLabel,
  project: getProjectLabel,
}
